export const fileRecognizerInitialState = {
  files: {},
  waitingFiles: [],
  recognizedFiles: [],
  classifyFiles: false,
};
